<ng-container *ngIf="isLoading; else dataGrid">
  <app-loader />
</ng-container>

<ng-template #dataGrid>
  <div class='p-1 p-sm-4 bg-dashboard-card br-9'>
    <!-- Error state -->
    <div *ngIf="hasError" class="alert alert-danger d-flex align-items-center justify-content-between" role="alert">
      <div>
        <i class="fas fa-exclamation-triangle me-2"></i>
        <span>{{ errorMessage }}</span>
      </div>
      <button class="btn btn-sm btn-outline-danger" (click)="retryLoad()">
        <i class="fas fa-redo me-1"></i>
        {{ 'BUTTONS.RETRY' | translate }}
      </button>
    </div>

    <!-- Empty state -->
    <div *ngIf="!hasError && data.length === 0" class="alert alert-info text-center" role="alert">
      <i class="fas fa-info-circle me-2"></i>
      {{ 'TESTS.NO_TESTS_AVAILABLE' | translate }}
    </div>

    <!-- Data grid (table partagée) -->
    <app-custom-tab *ngIf="!hasError && data.length > 0"
      [data]="data" [columns]="columns"
      [cellTemplates]="{ testMode: modeTpl, questionsCount: countTpl, attempts: attemptsTpl }"
      [actionTemplate]="actionsTpl" [locale]="currentLocale" [enableRtl]="enableRTL">
    </app-custom-tab>

    <ng-template #modeTpl let-data>
      <span class="badge" [ngClass]="{
              'bg-primary': data.testMode === 'exam',
              'bg-success': data.testMode === 'practice',
              'bg-info': data.testMode === 'evaluation'
            }">
        {{ translateTestMode(data.testMode) }}
      </span>
    </ng-template>

    <ng-template #countTpl let-data>
      <span class="badge bg-secondary">{{ data.questionsCount }}</span>
    </ng-template>

    <ng-template #attemptsTpl let-data>
      <ng-container *ngIf="data.studentSummary; else noAttemptData">
        <div class="d-flex flex-column align-items-center gap-1">
          <span class="fw-semibold">
            {{ data.maxAttempts - data.studentSummary.remainingAttempts }} / {{ data.maxAttempts }}
          </span>
          <span class="badge"
            [ngClass]="data.studentSummary.remainingAttempts > 0 ? 'bg-success' : 'bg-danger'">
            {{ data.studentSummary.remainingAttempts }} {{ 'TESTS.REMAINING' | translate }}
          </span>
        </div>
      </ng-container>
      <ng-template #noAttemptData>
        <span class="text-muted">{{ 'TESTS.NO_DATA' | translate }}</span>
      </ng-template>
    </ng-template>

    <ng-template #actionsTpl let-data>
      <button class="btn btn-sm"
        [ngClass]="data.studentSummary?.hasActiveSession ? 'btn-warning' : 'btn-success'"
        (click)="startOrResume(data)"
        [disabled]="data.studentSummary?.remainingAttempts === 0 && !data.studentSummary?.hasActiveSession"
        [title]="data.studentSummary?.hasActiveSession ? ('BUTTONS.RESUME' | translate) : ('BUTTONS.START' | translate)">
        <i class="fas me-1"
          [ngClass]="data.studentSummary?.hasActiveSession ? 'fa-play-circle' : 'fa-play'"></i>
        {{
          data.studentSummary?.hasActiveSession
            ? ('BUTTONS.RESUME' | translate)
            : ('BUTTONS.START' | translate)
        }}
      </button>
    </ng-template>
  </div>
</ng-template>